import { FormikValues } from 'formik'

export interface CreateMaturityComplianceRuleValues extends FormikValues {
  displayTextKey: string
  maturityDaysFrom: number
  maturityDaysTo: number
  maxLimit: number
  minLimit: number
}

export const createMaturityComplianceRuleValues: CreateMaturityComplianceRuleValues = {
  displayTextKey: null,
  maturityDaysFrom: 0,
  maturityDaysTo: 0,
  maxLimit: 0,
  minLimit: 0,
}
